export default function arrayOrArray<T>(o: T | T[] | undefined): T[] {
  if (o === undefined) return [];

  return (Array.isArray(o) ? o : [o]) as T[];
}
